export default __webpack_public_path__ + "static/media/fade.db5ebb84.jpg";